import { Box, Chair, Cup, Desk, Lamp, Laptop, P, Pendant, PersonSeated, Plant, Shadow } from "@/components/workspaces/IsoKit";

const V = ({ label, children }) => (
    <svg viewBox="0 0 640 260" preserveAspectRatio="xMidYMid slice" className="h-full w-full" role="img" aria-label={label}>
        <g transform="translate(0,-150)">{children}</g>
    </svg>
);

export const TeamVignette = () => (
    <V label="Conceptual visualization of a team collaborating at Work Island">
        <Shadow x={0} y={10} rx={95} ry={28} />
        <Chair x={-45} y={-24} facing={1} />
        <Chair x={45} y={-24} facing={1} />
        <Chair x={-45} y={44} facing={-1} />
        <Chair x={45} y={44} facing={-1} />
        <Box x={0} y={10} w={100} d={9} z0={20} h={32} t="#C4CCDD" l="#AEB7CB" r="#9AA5BE" />
        <Box x={0} y={10} w={150} d={54} z0={52} h={6} t="#FFFFFF" l="#E9ECF3" r="#DDE1EC" stroke="#D5DAE6" />
        <PersonSeated x={-45} y={-22} color="#33415C" />
        <PersonSeated x={45} y={-22} color="#526179" />
        <PersonSeated x={-45} y={42} color="#2AA79A" />
        <Laptop x={-18} y={4} z={58} />
        <Cup x={28} y={18} z={58} />
        <Pendant x={0} y={10} />
    </V>
);

export const SoloVignette = () => (
    <V label="Conceptual visualization of an individual workstation at Work Island">
        <Shadow x={0} y={0} rx={95} ry={28} />
        <Desk x={0} y={0} w={170} divider={false} />
        <Chair x={0} y={36} facing={-1} />
        <PersonSeated x={0} y={36} color="#33415C" />
        <Laptop x={0} y={-6} z={58} />
        <Lamp x={-58} y={4} z={58} />
        <Cup x={40} y={-4} z={58} />
        <Plant x={120} y={-60} s={0.8} />
    </V>
);

export const RemoteVignette = () => (
    <V label="Conceptual visualization of a plug-and-play desk at Work Island">
        <Shadow x={0} y={0} rx={90} ry={26} />
        <Desk x={0} y={0} w={170} divider={false} />
        <Chair x={0} y={36} facing={-1} />
        <Laptop x={0} y={-6} z={58} />
        <Cup x={-40} y={-4} z={58} />
        <Plant x={-120} y={-60} s={0.85} />
        <Plant x={125} y={40} s={0.7} />
    </V>
);

export const SmallBizVignette = () => (
    <V label="Conceptual visualization of a small team workspace at Work Island">
        <Shadow x={0} y={0} rx={120} ry={30} />
        <Desk x={-62} y={0} w={130} divider={false} />
        <Desk x={88} y={0} w={130} divider={false} />
        <Chair x={-62} y={36} facing={-1} />
        <Chair x={88} y={36} facing={-1} />
        <PersonSeated x={-62} y={36} color="#33415C" />
        <PersonSeated x={88} y={36} color="#526179" />
        <Laptop x={-62} y={-6} z={58} />
        <Laptop x={88} y={-6} z={58} />
        <Plant x={12} y={-78} s={0.75} />
    </V>
);

export const ConsultVignette = () => (
    <V label="Conceptual visualization of a client meeting at Work Island">
        <Shadow x={0} y={0} rx={70} ry={22} />
        <Chair x={0} y={-52} facing={1} />
        <Chair x={0} y={52} facing={-1} />
        <PersonSeated x={0} y={-50} color="#33415C" />
        <PersonSeated x={0} y={50} color="#2AA79A" />
        <Box x={0} y={0} w={62} d={62} z0={46} h={6} t="#FFFFFF" l="#E9ECF3" r="#DDE1EC" stroke="#D5DAE6" />
        <Box x={0} y={0} w={10} d={10} z0={20} h={26} t="#C4CCDD" l="#AEB7CB" r="#9AA5BE" />
        <Cup x={-14} y={-8} z={52} />
        <Cup x={14} y={10} z={52} />
    </V>
);

export const StudentVignette = () => (
    <V label="Conceptual visualization of a study desk at Work Island">
        <Shadow x={0} y={0} rx={90} ry={26} />
        <Desk x={0} y={0} w={170} divider={false} />
        <Chair x={0} y={36} facing={-1} />
        <Laptop x={-28} y={-6} z={58} />
        <Box x={34} y={-4} w={16} d={11} z0={58} h={2.5} t="#8A4BB0" l="#74409A" r="#653889" />
        <Lamp x={-66} y={4} z={58} />
        <Cup x={62} y={0} z={58} />
        <Plant x={125} y={-55} s={0.75} />
    </V>
);

export const VisitorVignette = () => (
    <V label="Conceptual visualization of a visiting professional's desk at Work Island">
        <Shadow x={0} y={0} rx={95} ry={28} />
        <Desk x={-14} y={0} w={160} divider={false} />
        <Chair x={-14} y={36} facing={-1} />
        <Laptop x={-14} y={-6} z={58} />
        <Cup x={30} y={-2} z={58} />
        <Box x={72} y={42} w={24} d={15} z0={20} h={30} t="#46536F" l="#3A4763" r="#333F59" />
        <line x1={P(72, 42, 50)[0]} y1={P(72, 42, 50)[1]} x2={P(72, 42, 58)[0]} y2={P(72, 42, 58)[1]} stroke="#333F59" strokeWidth={3} />
        <Plant x={-120} y={-60} s={0.8} />
    </V>
);
